import React from "react";
import Helmet from "react-helmet";
import Img from "gatsby-image";
import Link from "gatsby-link";
import PostListing from "../components/PostListing/PostListing";
import SEO from "../components/SEO/SEO";
import config from "../../data/SiteConfig";
import VideoBackground from "../components/VideoBackground";

import "../styles/index.scss";

class Index extends React.Component {
  render() {
    const {
      data: {
        allMarkdownRemark: {
          edges
        },
        oncezoneLogoImg,
        backgroundImg,
        subbedVideosImg,
        weeklyRecapsImg,
        twiceScheduleImg,
      }
    } = this.props;
    return (
      <div>
        <Helmet title={config.siteTitle} />
        <SEO postEdges={edges} />
        <div className="indexBackground">
          <div className="backgroundDarken" />
          <VideoBackground />
          <Img
            className="backgroundImage"
            sizes={backgroundImg.childImageSharp.sizes}
          />
        </div>
        <div className="hero is-fullheight">
          <div className="hero-body">
            <div className="container has-text-centered">
              <Img
                sizes={oncezoneLogoImg.childImageSharp.sizes}
                style={{
                  maxWidth: "400px",
                  margin: "0 auto 0 auto"
                }}
              />
              <h2 className="title is-2 has-text-white">
                Content for ONCE by ONCE
              </h2>
              <Link to="/videos">
                <button className="button is-link is-large is-rounded landing-button" type="button">
                  Subbed Videos
                </button>
              </Link>
              <Link to="/posts">
                <button className="button is-link is-large is-rounded landing-button" type="button">
                  Weekly Recaps
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="contents">
          <div className="section">
            <div className="container">
              <h1 className="title is-1">
                Contents
              </h1>
              <div className="columns">
                <div className="column is-one-third">
                  <Link to="/videos">
                    <Img
                      className="contentCircles"
                      sizes={subbedVideosImg.childImageSharp.sizes}
                    />
                  </Link>
                </div>
                <div className="column is-one-third">
                  <Link to="/posts">
                    <Img
                      className="contentCircles"
                      sizes={weeklyRecapsImg.childImageSharp.sizes}
                    />
                  </Link>
                </div>
                <div className="column is-one-third">
                  <Link to="/schedule">
                    <Img
                      className="contentCircles"
                      sizes={twiceScheduleImg.childImageSharp.sizes}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <div className="container">
            <h1 className="title is-1">
              Recent Uploads
            </h1>
            <PostListing
              postEdges={edges}
              dateFormat={config.dateFormatOutput}
            />
            <div className="has-text-centered">
              <Link to="/videos" className="button is-link is-medium">
                View All
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Index;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      limit: 4
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {frontmatter: {category: {eq: "video"}}}
    ) {
      edges {
        node {
          fields {
            slug
            title
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            date
          }
          localThumbnail {
            childImageSharp {
              sizes(maxHeight: 240, maxWidth: 2133) {
                ...GatsbyImageSharpSizes_tracedSVG
              }
            }
          }
        }
      }
    }

    oncezoneLogoImg: file(relativePath: { eq: "logos/oncezone-large.png" }) {
      childImageSharp {
        sizes(maxWidth: 400) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    backgroundImg: file(relativePath: { eq: "bg/index.png" }) {
      childImageSharp {
        sizes(maxWidth: 1920, toFormat: JPG) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    subbedVideosImg: file(relativePath: { eq: "contents/subbed-videos.png" }) {
      childImageSharp {
        sizes(maxWidth: 256) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    weeklyRecapsImg: file(relativePath: { eq: "contents/weekly-recaps.png" }) {
      childImageSharp {
        sizes(maxWidth: 256) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    twiceScheduleImg: file(relativePath: { eq: "contents/twice-schedule.png" }) {
      childImageSharp {
        sizes(maxWidth: 256) {
          ...GatsbyImageSharpSizes
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx